import "./style.css";
import App from "./App.svelte";

const target = document.getElementById("app");
if (!target) throw new Error("#app missing in index.html");
new App({ target });
